/* SIPSY cart drawer: opens on add to cart or cart icon, free shipping bar, next-offer upsell, social proof. */
(() => {
  const root = document.querySelector('[data-sp-cart]');
  if (!root) return;

  const cfg = root.dataset;
  const threshold = Number(cfg.threshold) || 0;
  const packVariant = Number(cfg.variantId) || 0;
  const unit = Number(cfg.unit) || 0;
  const squad = Number(cfg.squad) || 0;
  const moneyFormat = cfg.moneyFormat || 'R {{amount}}';
  const cta = cfg.cta || 'CHECKOUT';
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const el = name => root.querySelector(`[data-sp-cart-${name}]`);
  const panel = root.querySelector('.sp-cart__panel');
  const ship = el('ship');
  const items = el('items');
  const upsell = el('upsell');
  const empty = el('empty');
  const foot = el('foot');
  const proof = el('proof');
  const countLabel = el('count');

  let lastFocus = null;
  let busy = false;

  const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));

  function money(cents) {
    const value = cents / 100;
    const whole = Number.isInteger(value);
    const amount = value.toLocaleString('en-US', {minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2});
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (match, key) => {
      if (key === 'amount_no_decimals') return Math.round(value).toLocaleString('en-US');
      if (key === 'amount_with_comma_separator') return amount.replace(/,/g, ' ').replace('.', ',');
      return amount;
    });
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  }

  async function request(path, options) {
    const response = await fetch(base + path, Object.assign({headers: {Accept: 'application/json'}}, options));
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(data.description || data.message || 'Cart error'), {data});
    return data;
  }

  const getCart = () => request('cart.js');
  const changeLine = (key, quantity) => request('cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json', Accept: 'application/json'},
    body: JSON.stringify({id: key, quantity})
  });

  function updateBubbles(count) {
    document.querySelectorAll('#cart-icon-bubble .sp-count').forEach(bubble => {
      bubble.innerHTML = `<span aria-hidden="true">${count}</span><span class="sp-visually-hidden">${count} items</span>`;
    });
  }

  function packLabel(quantity) {
    const stickers = quantity * 4;
    return `${quantity} ${quantity === 1 ? 'pack' : 'packs'} · ${stickers} stickers`;
  }

  function renderShip(total) {
    if (!threshold) { ship.hidden = true; return; }
    ship.hidden = false;
    const remaining = threshold - total;
    const pct = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
    const text = remaining > 0
      ? `You're <b>${money(remaining)}</b> away from <b>free shipping</b>`
      : `<b>You've unlocked free shipping</b> ♥`;
    ship.innerHTML = `<p>${text}</p><div class="sp-cart__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${pct}" aria-label="Progress to free shipping"><span style="width:${pct}%"></span></div>`;
  }

  function renderItems(cart) {
    items.innerHTML = cart.items.map(item => {
      const isPack = item.variant_id === packVariant;
      const meta = isPack ? packLabel(item.quantity) : (item.variant_title || '');
      const saved = item.original_line_price > item.final_line_price;
      return `<li class="sp-cart-item" data-key="${esc(item.key)}">
        <img src="${esc(sized(item.image, 200))}" alt="" width="72" height="72" loading="lazy">
        <div class="sp-cart-item__info">
          <p class="sp-cart-item__title">${esc(item.product_title)}</p>
          ${meta ? `<p class="sp-cart-item__meta">${esc(meta)}</p>` : ''}
          <div class="sp-cart-item__row">
            <div class="sp-cart-qty" role="group" aria-label="Quantity">
              <button type="button" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span aria-live="polite">${item.quantity}</span>
              <button type="button" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <p class="sp-cart-item__price">${saved ? `<s>${money(item.original_line_price)}</s>` : ''}${money(item.final_line_price)}</p>
          </div>
          <button type="button" class="sp-cart-item__remove" data-qty="0">Remove</button>
        </div>
      </li>`;
    }).join('');
  }

  function renderUpsell(cart) {
    const line = cart.items.find(item => item.variant_id === packVariant);
    if (!line || !unit) { upsell.innerHTML = ''; return; }
    const q = line.quantity;
    const discounted = line.original_line_price > line.final_line_price;
    let html = '';
    if (q === 1) {
      html = `<div class="sp-cart-up">
        <div><p class="sp-cart-up__eyebrow">Most popular</p><p class="sp-cart-up__title">Make it 2 Packs</p><p class="sp-cart-up__text">One for you, one for a friend. Unlocks free shipping.</p></div>
        <button type="button" class="sp-cart-up__btn" data-up-key="${esc(line.key)}" data-up-qty="2">ADD · +${money(unit)}</button>
      </div>`;
    } else if (q < 4 && squad) {
      const need = 4 - q;
      const extra = squad - unit * q;
      const saving = unit * 4 - squad;
      html = `<div class="sp-cart-up sp-cart-up--squad">
        <div><p class="sp-cart-up__eyebrow">Best value</p><p class="sp-cart-up__title">Upgrade to the Squad Pack</p><p class="sp-cart-up__text">Add ${need} more ${need === 1 ? 'pack' : 'packs'} and save ${money(saving)}. One for you and your friends.</p></div>
        <button type="button" class="sp-cart-up__btn" data-up-key="${esc(line.key)}" data-up-qty="4">UPGRADE · +${money(extra)}</button>
      </div>`;
    } else if (q >= 4 && discounted) {
      html = `<div class="sp-cart-up sp-cart-up--done"><p class="sp-cart-up__title">♥ Squad Pack price unlocked</p><p class="sp-cart-up__text">You're saving ${money(line.original_line_price - line.final_line_price)} on this order.</p></div>`;
    }
    upsell.innerHTML = html;
  }

  function renderFoot(cart) {
    const saving = cart.items.reduce((sum, item) => sum + (item.original_line_price - item.final_line_price), 0) + (cart.cart_level_discount_applications || []).reduce((sum, d) => sum + (d.total_allocated_amount || 0), 0);
    const freeShip = threshold && cart.total_price >= threshold;
    foot.innerHTML = `
      ${saving > 0 ? `<p class="sp-cart-foot__row sp-cart-foot__save"><span>Savings</span><span>−${money(saving)}</span></p>` : ''}
      <p class="sp-cart-foot__row"><span>Shipping</span><span>${freeShip ? 'Free' : 'Calculated at checkout'}</span></p>
      <p class="sp-cart-foot__row sp-cart-foot__total"><span>Total</span><span>${money(cart.total_price)}</span></p>
      <a href="${base}checkout" class="sp-button sp-button--dark sp-cart-foot__checkout">${esc(cta)} · ${money(cart.total_price)}</a>
      <p class="sp-cart-foot__note">${esc(cfg.checkoutNote || '')}</p>`;
  }

  function render(cart) {
    updateBubbles(cart.item_count);
    countLabel.textContent = cart.item_count ? `(${cart.item_count})` : '';
    const isEmpty = !cart.items.length;
    empty.hidden = !isEmpty;
    items.hidden = isEmpty;
    foot.hidden = isEmpty;
    if (proof) proof.hidden = isEmpty;
    renderShip(cart.total_price);
    if (isEmpty) { items.innerHTML = ''; upsell.innerHTML = ''; foot.innerHTML = ''; return; }
    renderItems(cart);
    renderUpsell(cart);
    renderFoot(cart);
  }

  function setBusy(state) {
    busy = state;
    panel.classList.toggle('is-busy', state);
  }

  async function refresh() {
    try { render(await getCart()); } catch (error) { console.warn('[SIPSY cart]', error); }
  }

  function open() {
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('sp-cart-open');
    requestAnimationFrame(() => {
      root.classList.add('is-open');
      const close = root.querySelector('.sp-cart__close');
      if (close) close.focus({preventScroll: true});
    });
  }

  function close() {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('sp-cart-open');
    const done = () => { root.hidden = true; };
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ? done() : setTimeout(done, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({preventScroll: true});
  }

  async function openWithCart() {
    open();
    setBusy(true);
    await refresh();
    setBusy(false);
  }

  window.spCart = {open: openWithCart, close, refresh};

  root.addEventListener('click', async event => {
    if (event.target.closest('[data-sp-cart-close]')) { close(); return; }
    if (busy) return;
    const qtyButton = event.target.closest('[data-qty]');
    const upButton = event.target.closest('[data-up-qty]');
    const target = qtyButton || upButton;
    if (!target) return;
    const key = upButton ? upButton.dataset.upKey : target.closest('[data-key]').dataset.key;
    const quantity = Number(upButton ? upButton.dataset.upQty : qtyButton.dataset.qty);
    setBusy(true);
    try { render(await changeLine(key, Math.max(0, quantity))); }
    catch (error) { console.warn('[SIPSY cart]', error); await refresh(); }
    setBusy(false);
  });

  document.addEventListener('keydown', event => {
    if (root.hidden) return;
    if (event.key === 'Escape') { close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* Cart icon opens the drawer instead of the cart page. */
  document.addEventListener('click', event => {
    const link = event.target.closest('#cart-icon-bubble');
    if (!link || event.metaKey || event.ctrlKey) return;
    event.preventDefault();
    openWithCart();
  });

  /* Any add-to-cart form adds via AJAX, then opens the drawer. Falls back to a normal submit on error. */
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    const data = new FormData(form);
    data.delete('return_to');
    try {
      await request('cart/add.js', {method: 'POST', body: data});
      await openWithCart();
    } catch (error) {
      console.warn('[SIPSY cart]', error);
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (submit) submit.disabled = false;
    }
  });
})();
